import { TEAM_LINE, getCloudinaryRawUrl } from "@swiggy-private/js-utils";
import { ERROR_IMAGE_ID_UX4 } from "../components/generic-error/constants";

export const IMAGE_ASSETS = {
    ERROR_IMAGE_ID_UX4,
};

export const IMAGE_ASSETS_TO_PRECACHE = Object.values(IMAGE_ASSETS).map((assetId) =>
    getCloudinaryRawUrl(
        assetId,
        {},
        {
            teamLine: TEAM_LINE.PORTAL,
        },
    ),
);
